// Can users configure prepreg layer of the stackup?
export const ALLOW_PREPREG_CONFIGURATION = true;

export const ALLOW_EDIT_MATERIAL_NAME = false;


// WEBPACK FOOTER //
// ./src/constants/features.js